/* import __COLOCATED_TEMPLATE__ from './expedite-commitment-modal.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { closeModal } from 'sh-www/utils/modal-controls';

const CLASS_NAME = 'SH-c-expedite-commitment-modal';

class ExpediteCommitmentModal extends Component {
  get className() {
    return CLASS_NAME;
  }

  get combinedServiceFees() {
    return this.args.model.creatorFee + this.args.model.buyerFee;
  }

  @action
  handleClose() {
    this.args.model.unsetToggle();
    closeModal(this);
  }

  @action
  handleSubmit() {
    this.args.model.confirmAction();
    closeModal(this);
  }
}

export default ExpediteCommitmentModal;
